






import Vue from 'vue'
import { AntrFileElInterface } from '@/config/interfaces'

export default Vue.extend({
  name: 'AntrFileEl',
  props: {
    templateItemData: {
      type: Object as () => AntrFileElInterface,
      required: true
    }
  },
  computed: {
    style (): string {
      return 'background: ' + this.templateItemData.background + '; ' +
        'color: ' + this.templateItemData.color + ' !important; ' +
        'text-align: ' + this.templateItemData.align + ';'
    }
  }
})
